'use client';

import ContactButton from '../ContactButton';
import { HeroBlock } from '@/payload-types';
import { Media } from '@onclicks/sharedcomponents/Media/Media';

const HighImpactHero: React.FC<HeroBlock> = (props) => {
  const { media, title, subtitle, links } = props;
  return (
    <div className="overflow-x-hidden">
      <svg
        className="absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
        aria-hidden="true"
      >
        <defs>
          <pattern
            id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
            width={200}
            height={200}
            x="50%"
            y={-1}
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none" />
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth={0}
          fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
        />
      </svg>
      <div className="mx-auto max-w-7xl xsmall:px-6 xsmall:py-16 lg:flex lg:px-8">
        <div className="mx-auto flex max-w-2xl flex-col justify-center lg:mx-0 lg:max-w-xl lg:flex-shrink-0">
          <h1 className="mt-10 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
            {title}
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">{subtitle}</p>
          {links && <ContactButton links={links} className="mt-6" />}
        </div>
        <div className="mx-auto mt-16 flex max-w-2xl sm:mt-24 lg:ml-10 lg:mr-0 lg:mt-0 lg:max-w-none lg:flex-none xl:ml-32">
          <div className="max-w-3xl flex-none sm:max-w-5xl lg:max-w-none">
            <div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
              <Media
                resource={media}
                className="h-auto max-w-[76rem] rounded-md shadow-2xl ring-1 ring-gray-900/10"
                size="(min-width: 64rem) 76rem, 100vw"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HighImpactHero;
